module.exports = __webpack_public_path__ + "img/Product.b7bbca05.png";